import React from 'react';

interface DashboardGridProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Grid responsive auto-adaptatif
 *
 * Breakpoints automatiques:
 * - S21 (360px): 2 colonnes
 * - iPhone (375-414px): 2-3 colonnes
 * - Tablet (768px): 4 colonnes
 * - Desktop (1024px+): 5+ colonnes
 */
export const DashboardGrid: React.FC<DashboardGridProps> = ({children, className = ''}) => {
  return (
    <div
      className={className}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 165px), 1fr))',
        gap: '1rem',
        padding: '1rem',
        width: '100%',
      }}
    >
      {children}
    </div>
  );
};